import { UserRole } from '~features/PrerenderUser';

// Its own file because both GSC cards need it and `Integrations.tsx` imports
// the cards — declaring it there and importing it back would be a cycle.
export const GSC_DISABLED_ROLES = [UserRole.BillingManager, UserRole.Guest];
